import { useModal } from "@ebay/nice-modal-react";
import { t } from "@/i18n-js/instance";
import { MomentumModal } from "@circle-react-shared/ModalsV2/MomentumModal";
import { ModalManager } from "../Layout/ModalManagerProvider";
import { Icon } from "../shared/Icon";
import { ActionButton } from "../shared/ModalsV2/MomentumModal/ActionButton";
import type { PostForQuickPost } from "./Form";
import { useConvertPostToBroadcast } from "./useConvertPostToBroadcast";

export const PostMomentumModal = ModalManager.create(function PostMoMo({
  post,
}: {
  post: PostForQuickPost;
}) {
  const modal = useModal();
  const { onSendAnnouncement, isLoading } = useConvertPostToBroadcast();

  const handleSendAnnouncement = () => {
    onSendAnnouncement({ postId: post.id, onSuccess: () => void modal.hide() });
  };

  return (
    <MomentumModal
      isOpen={modal.visible}
      onClose={modal.hide}
      title={t("quick_post_v2.connection_modal.title")}
      description={t("quick_post_v2.connection_modal.description", {
        space_name: post.space_name,
      })}
      isLoading={isLoading}
    >
      <ActionButton
        iconEl={<Icon type="email-filled" size={20} />}
        onClick={handleSendAnnouncement}
        disabled={isLoading}
        data-testid="send-announcement-button"
      >
        {t("quick_post_v2.connection_modal.send_announcement")}
      </ActionButton>
    </MomentumModal>
  );
});
